/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { INSPECTOR_NODE_TYPE, TInspectorNode } from "../InspectorNodeTypes";
import { ISchemaThemeRefModel, isSchemaThemeRefModel, TGenericModelNode } from "@adapptio/lib-blueprint";
import { mapperDescriptor } from "../../modules/Core/ReferenceGuide/mappers/mapperDescriptor";
import { mapperExamples } from "../../modules/Core/ReferenceGuide/mappers/mapperExamples";
import { getParentComponentName } from "../utils";
import { mapModelToNodes } from "../mapModelToNodes";

export function themeRefMapper(model: ISchemaThemeRefModel): TInspectorNode {
	if (!isSchemaThemeRefModel(model)) {
		return;
	}

	const deps: TGenericModelNode[] = [ model, model.themeId ];
	const controls = [];

	const themeIdNode = mapModelToNodes(model.themeId);

	if (themeIdNode) {
		deps.push(...themeIdNode.deps);
		controls.push(...themeIdNode.controls);
	}

	if (model.styleName) {
		deps.push(model.styleName);
	}

	if (model.styleName?.value) {
		deps.push(model.styleName.value);
	}

	return {
		type: INSPECTOR_NODE_TYPE.DEFAULT,
		key: `${model.nodeId}`,
		label: "",
		tooltip: "",
		deps: deps,
		controls: [],
		children: [
			() => {
				return {
					type: INSPECTOR_NODE_TYPE.DEFAULT,
					key: `${model.nodeId}`,
					label: model.schema.opts.label,
					tooltip: model.schema.opts.description,
					required: model.schema.opts.constraints?.required || false,
					default: model.schema.opts["default"] || null,
					options: model.schema.opts["options"],
					referenceData: getParentComponentName(model),
					descriptor: mapperDescriptor(model.schema),
					examples: mapperExamples(model.schema),
					deps: deps,
					controls: controls,
					children: []
				};
			},
			() => mapModelToNodes(model.styleName?.value)
		]
	};
}
